module.exports = __webpack_public_path__ + "static/media/chart-pie.dac4c2c1.svg";